
import * as actionType from "../../actions/analysisPageActions/actions"

// exam analysis reducer
const INITIAL_EXAM_ANALYSIS_STATE = {
  isLoading: false,
  output: null,
  status:false,
  writtenExamTypes: [],
  error: null,
};

const examAnalysisReducer = (state = INITIAL_EXAM_ANALYSIS_STATE, action) => {
  switch (action.type) {
    case actionType.FETCH_EXAM_ANALYSIS:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    
    case actionType.FETCH_EXAM_ANALYSIS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        output: action.payload.output || null,
        status: action.payload.status,
        writtenExamTypes: action.payload.writtenExamTypes || [],
        error: null,
      };
    
    case actionType.FETCH_EXAM_ANALYSIS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    
    case actionType.CLEAR_EXAM_ANALYSIS:
      return {
        ...INITIAL_EXAM_ANALYSIS_STATE,
      };
    
    default:
      return state;
  }
};

export { examAnalysisReducer };